import barba from '@barba/core';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import LocomotiveScroll from 'locomotive-scroll';

import header from './components/header';
import headerChanges from './components/headerChanges.js';
import fullSlider from './components/fullSlider.js';
import simpleSlider from './components/simpleSlider.js';
import cardSlider from './components/cardSlider.js';
import accordion from './components/accordion.js';
import teamProfileSlider from './components/teamProfileSlider.js';
import mediaSlider from './components/mediaSlider.js';
import cookiePopup from './components/cookie-popup';
import contactForm from './components/contactForm.js';
import portfolioTabs from './components/portfolio-tabs';
import heroSlider from './components/heroSlider.js';
import hiddenBlocks from './components/hiddenBlocks.js';
import fourItems from './components/fourItems.js';
import featuredSlider from './components/featuredSlider.js';
import categoryGridSlider from './components/categoryGridSlider.js';
import documents from './components/documents.js';
import sortFilter from './components/sortFilter.js';
import threeCardsSlider from './components/threeCardsSlider.js';
import threeCardsSliderModify from './components/threeCardsSliderModify.js';
import simpleBlockSlider from './components/simpleBlockSlider.js';
import fadeInEls from './components/fadeInEls.js';
import portalMenu from './components/portalMenu';
import addGoogleMaps from './components/addGoogleMaps.js';
import plyrVideo from './components/plyr-video';


export default () => {
  let scroller;
  init(scroller);

  function init(scroller) {
		let touchMultiplier = window.innerWidth <= 767 ? 5 : 4;
    scroller = new LocomotiveScroll({
      el: document.querySelector('[data-scroll-container]'),
      smooth: true,
      resetNativeScroll: true,
      touchMultiplier: touchMultiplier,
      smoothMobile: 0,
      smartphone: {
          smooth: !0,
          breakpoint: 767,
          resetNativeScroll: true,
      },
      tablet: {
          smooth: !1,
          breakpoint: 1024
      },



      // tablet: {
      //   smooth: true,
      // },
      // smartphone: {
      //   smooth: true,
      // }
    });
  
    barbaInit(scroller);


    window.addEventListener('resize', () => {
      scroller.update();
    });

    document.addEventListener('click', () => {
      scroller.update();
    });
      
    preload();
    header(scroller);
    headerChanges(scroller);
    fullSlider();
    heroSlider();
    accordion(scroller);
    simpleSlider();
    cardSlider(scroller);
    teamProfileSlider(scroller);
    mediaSlider(scroller);
    cookiePopup(scroller);
    contactForm();
    portfolioTabs(scroller);
    hiddenBlocks(scroller);
    fourItems();
    featuredSlider();
    categoryGridSlider();
    documents(scroller);
    sortFilter(scroller);
    threeCardsSlider();
    threeCardsSliderModify();
    simpleBlockSlider();
    fadeInEls(scroller);
    portalMenu(scroller);
		plyrVideo();
    addGoogleMaps();
  
  }

  function pageChange(scroller) {
    scroller.destroy();
    scroller.init();

    headerChanges(scroller);
    fullSlider();
    heroSlider();
    accordion(scroller);
    simpleSlider();
    cardSlider(scroller);
    teamProfileSlider(scroller);
    mediaSlider(scroller);
    contactForm();
    portfolioTabs(scroller);
    hiddenBlocks(scroller);
    fourItems();
    featuredSlider();
    categoryGridSlider();
    documents(scroller);
    sortFilter(scroller);
    threeCardsSlider();
    threeCardsSliderModify();
    simpleBlockSlider();
    fadeInEls(scroller);
    portalMenu(scroller);
		plyrVideo();
    addGoogleMaps();
  }




  function barbaInit(scroller) {

    const TIMING_TRANSITION = 1;
    const ARABIC = '__arabic';

    let header = document.querySelector('.header');

    const HEADER_COLORS = {
      pagesPage: 'header--dark', // class for dark header
      homePage: '', // class for light header
      aboutUsPage: '',
      careersPage: '',
      caseStudyPage: 'header--dark',
      communityPage: '',
      contactPage: '',
      corporateGovernancePage: '',
      eventsItemPage: 'header--dark',
      eventsPage: 'header--dark',
      FAQPage: '',
      galleryItemPage: 'header--dark',
      investmentPage: '',
      mediaPage: 'header--dark',
      newsAndMediaPage: '',
      newsItemPage: 'header--dark',
      newsPage: 'header--dark',
      ourBoardPage: 'header--dark',
      ourHistoryPage: '',
      portfolioArchivePage: '',
      portfolioSinglePage: 'header--dark',
      pressReleasesPage: 'header--dark',
      searchPage: 'header--dark',
      seniorManagementPage: 'header--dark',
      teamProfilePage: 'header--dark',
      videoItemPage: 'header--dark',
      whatWeDoPage: '',
      whoWeArePage: '',
    };

		barba.init({
      debug: true,
      cacheIgnore: true,
			transitions: [
				{
					leave(data) {
						const done = this.async();

						gsap
							.to(data.current.container, {
                opacity: 0,
                y: 100,
								duration: TIMING_TRANSITION,
							})
							.eventCallback('onComplete', function () {
								done();
							});
					},

					beforeEnter(data) {
            data.current.container.remove();

            for (let page in HEADER_COLORS) {
              if (HEADER_COLORS[page]) {
                header.classList.remove(HEADER_COLORS[page]);
              }
            }

            let namespace = data.next.namespace;

            if (HEADER_COLORS[namespace]) {
              header.classList.add(HEADER_COLORS[namespace]);
            }

						
            pageChange(scroller);
						let headerAnchors = document.querySelector('.header__anchors');
						if(headerAnchors) headerAnchors.classList.remove('anchors-visible');
						let headerFilters = document.querySelector('.header__filters');
						if(headerFilters) headerFilters.classList.remove('filters-visible');

            document.body.dataset.pageName = namespace;
            scroller.scrollTo(0,0);

            let nextHref = data.next.url.href;
            let currentHref = data.current.url.href;

            if(nextHref.includes(ARABIC)){
              document.body.classList.add('arabic');
            } else {
              document.body.classList.remove('arabic');
            }

            if((nextHref.includes(ARABIC) && !currentHref.includes(ARABIC)) || (!nextHref.includes(ARABIC) && currentHref.includes(ARABIC))){
              window.location.reload();
            }

					},

					enter(data) {
						const done = this.async();
        
						gsap
							.fromTo(
								data.next.container,
								{
                  opacity: 0,
                  y: 100,
								},

								{
                  opacity: 1,
                  y: 0,
									duration: TIMING_TRANSITION,
								}
							)
							.eventCallback('onComplete', function () {
								done();
							});
					},
				},
			],
		});

    barba.hooks.beforeEnter( ( data ) => {
      
      var head = document.querySelector('.header__breadcrumbs'),
        dataHTML = data.next.html,
        newPageRawHead = dataHTML.match( /<header[^>]*>([\s\S.]*)<\/header>/i )[ 0 ],
        newPageHead = document.createElement( 'header' );

        newPageHead.innerHTML = newPageRawHead;
        let headTags = [ 
            ".header__breadcrumbs-list"
        ].join( ',' );
        
        let oldHeadTags = head.querySelectorAll( headTags );
        for ( let i = 0; i < oldHeadTags.length; i++ ) {
          head.removeChild( oldHeadTags[ i ] );
        }

        let newHeadTags = newPageHead.querySelectorAll( headTags );
        for ( let i = 0; i < newHeadTags.length; i++ ) {
          head.appendChild( newHeadTags[ i ] );
        }
    } );

  }
}

function preload() {
  gsap.set('.page-wrapper', {
    opacity: 0,
        y: 100,
  });

  gsap
    .to('.page-wrapper', {
      opacity: 1,
      y: 0,
      duration: 1,
    });
}